module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Fb-Gc-Hc 后背.c1d1ea13.png";